export default __webpack_public_path__ + "static/media/homepage_image.b49d51ae.png";